package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BudgetDto(
    @SerialName("budget_id") val budgetId: String,
    @SerialName("name") val name: String,
    @SerialName("categories") val categories: List<String>,
    @SerialName("target_value") val targetValue: Double,
    @SerialName("created_at") val createdAt: String,
    @SerialName("last_updated_at") val lastUpdatedAt: String? = null,
    @SerialName("last_updated_by_user_id") val lastUpdatedByUserId: String? = null,
    @SerialName("created_by_user_id") val createdByUserId: String,
    @SerialName("dashboard_ids") val dashboardIds: List<String> = emptyList(),
)

@Serializable
data class CreateBudgetRequest(
    @SerialName("name") val name: String,
    @SerialName("categories") val categories: List<String>,
    @SerialName("target_value") val targetValue: Double,
    @SerialName("dashboard_ids") val dashboardIds: List<String>? = null,
)

@Serializable
data class UpdateBudgetRequest(
    @SerialName("name") val name: String? = null,
    @SerialName("categories") val categories: List<String>? = null,
    @SerialName("target_value") val targetValue: Double? = null,
    @SerialName("dashboard_ids") val dashboardIds: List<String>? = null,
)

@Serializable
data class BudgetListResponse(
    @SerialName("budgets") val budgets: List<BudgetDto>,
)
